<div v-bind:class="[tableClass, getClassName]">
    <div v-bind:class="getClassName + 'Header'">{{ $t(tableName) }}</div>
    <slot></slot>
</div>

